<template>
  <div class="SpecificExtraWorkArchiveDetails">
    <v-dialog v-model="visible" max-width="900">
      <box :title="$t('extraWorkDetails')">
        <v-row class="pa-2">
          <v-col cols="12" sm="6">
            <v-row>
              <v-col>{{ $t("PageNo") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.PAGENO }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <v-row>
              <v-col>{{ $t("RequestedPersonName") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.PersonName }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <v-row>
              <v-col>{{ $t("LastChangeDate") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.LastChangeDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <v-row>
              <v-col>{{ $t("status") }}:</v-col>
              <v-col>
                <span
                  class="text-value"
                  v-text="
                    item.statusType +
                    '-' +
                    (details.IsTransfer
                      ? 'انتقال داده شده'
                      : 'انتقال داده نشده')
                  "
                ></span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <v-row>
              <v-col>{{ $t("RequestDate") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.RecDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6">
            <v-row>
              <v-col>{{ $t("ApprovedPerson") }}:</v-col>
              <v-col>
                <span class="text-value" v-text="ApprovedPerson"></span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small v-if="visibleEdit" @click="edit">{{ $t("edit") }}</v-btn>
          <v-btn small v-if="visibleDelete" @click="deleteItem">{{
            $t("delete")
          }}</v-btn>
        </v-card-actions>

        <archive-detals-flow
          v-if="ShowExtraWorkWorkFlow"
          :pageNo="item.PAGENO ? item.PAGENO.toString() : ''"
          :pageType="5"
          :year="item.Year"
        />
        <div v-else class="text-center py-3">
          <span> روند جریان برگه های منتقل شده قابل مشاهده نمی باشد </span>
        </div>
      </box>
    </v-dialog>
  </div>
</template>

<script>
import ArchiveDetalsFlow from "./ArchiveDetalsFlow.vue";
import ResultType from "../../model/ResultType";
import RequestState from "../../model/RequestState";
import TextUtils from "../../utils/TextUtils";

export default {
  components: { ArchiveDetalsFlow },
  props: {},
  data() {
    return {
      visible: false,
      ShowExtraWorkWorkFlow: true,
      item: "",
      details: "",
      visibleEdit: false,
      visibleDelete: false,
      ApprovedPerson: "",
    };
  },
  methods: {
    show(item) {
      this.visible = true;
      this.item = item;
      console.log(item);
      this.GetSpecificEwDetailForPerson(item);
    },
    GetSpecificEwDetailForPerson(item) {
      const params = new URLSearchParams();
      params.append(
        "pageNo",
        TextUtils.convertToEnglishDigits(item.PAGENO.toString().trim())
      );
      params.append("dbkind", item.DBKIND);
      params.append("year", item.Year);

      this.$store
        .dispatch("GetSpecificEwDetailForPerson", { params })
        .then((result) => {
          if (result.type == "success") {
            if (result.data.Table.length > 0) {
              this.details = result.data.Table[0];

              if (!this.details.IsTransfer && item.DBKIND == 1) {
                this.ShowExtraWorkWorkFlow = true;
              } else {
                this.ShowExtraWorkWorkFlow = false;
              }

              this.checkActionsVisiblity();
              this.getApprovedPerson();
            }
          }
        });
    },
    hide() {
      this.visible = false;
    },
    getApprovedPerson() {
      if (this.details.ApprovedPerson.trim() == "-1") {
        this.ApprovedPerson = this.$t("webkartManager");
      } else if (this.details.ApprovedPerson.trim() == "000") {
        this.ApprovedPerson = this.$t("winkartManager");
      } else {
        let params = new URLSearchParams();
        params.append("perno", this.details.ApprovedPerson.trim());
        this.$store.dispatch("GetPersonFullName", { params }).then((result) => {
          if (result.type === ResultType.success) {
            this.ApprovedPerson = result.data;
          }
        });
      }
    },
    checkActionsVisiblity() {
      ////console.log(String.fromCharCode(1740));
      ////console.log(String.fromCharCode(1610));
      this.visibleEdit = false;
      this.visibleDelete = false;

      switch (this.item.status) {
        case 0: //darkhost avaliyeh
        case 1: //bargasht khordeh
        case 2: //ersal mojadad
        case 4: //rad shodeh
          //btnPrint.Visible = false;
          this.visibleEdit = true;

          if (this.item.status == 1) {
            //emkan hazfe darkhoste rad shodeh
            this.visibleDelete =
              this.$store.state.personel.personelDetail.Permission[15].toString() ==
              "1";
          } else {
            this.visibleDelete = true;
          }
      }
    },
    edit() {
      this.visible = false;
      //console.log(this.details);
      //console.log(this.item);

      let details = {
        PageNo: this.item.pageNO,
        Year: this.item.YEAR,
        DBKind: this.item.DBKIND,
        selectedPerno: this.item.perno,
        from: "request-extra-work-archive",
      };
      //this.details["Year"] = this.item.YEAR;
      if (this.item.isGroup == 1) {
        this.$router.push({
          name: "extrawork-group-request",
          params: { details: details },
        });
      } else {
        this.$router.push({
          name: "request-extra-work",
          params: { details: details },
        });
      }
    },
    deleteItem() {
      var params = [
        {
          PageNo: this.item.pageNO,
          Year: this.item.YEAR,
          //AdminPerno: this.item.perno.trim(),
          RequestState: RequestState.RequestState.Delete,
          ReasonOfAdmin: "",
          Status: "-1",
        },
      ];

      this.$store
        .dispatch("OprationOnExtraWorkRequest", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === "success") {
            this.$emit("refresh");

            if (result.data?.length > 0) {
              if (result.data[0].Status == "-1") {
                this.$refs.snackbar.show("error", result.data[0].Description);
              } else {
                var description = result.data[0].Description;
                this.$refs.snackbar.show("success", description);
              }
            }
          } else {
            this.$refs.snackbar.show("error", result.error);
          }
        });
    },
  },
};
</script>

<style>
</style>